import React from "react"
import { Container, Row, Col } from "reactstrap"
import Query from "../../apollo/queries"
import zipRatingQuery from "../../apollo/queries/zipRating"
import { currencyFormatter } from "../../utils"

const SectionIncome = ({ county }) => {
  const higherRatings = ["A+", "A", "A-", "B+", "B", "B-"]
  return (
    <section className="d-table w-100 bg-light">
      <Container className="mt-5 mb-5">
        <Row>
          <Col md={6} xs={12}>
            <h5>Median Income</h5>
            <h2>
              {county.rating.median_income
                ? currencyFormatter(county.rating.median_income)
                : "0"}
            </h2>
            <h5>Income Score</h5>
            <h2>
              {county.rating.income_score
                ? Math.ceil(county.rating.income_score)
                : "0"}
            </h2>
          </Col>
          <Col md={6} xs={12}>
            <div
              className="p-4 rounded shadow bg-primary position-relative"
              style={{ zIndex: "1" }}
            >
              <div className="progress-box">
                <h6 className="title text-light title-dark">Tax Rate</h6>
                <div
                  className="progress title-bg-dark"
                  style={{ height: "10px", padding: "3px" }}
                >
                  <div
                    className="progress-bar position-relative bg-black"
                    style={{
                      width: `${
                        county.rating.tax_rate
                          ? Math.ceil(county.rating.tax_rate * 100)
                          : 0
                      }%`,
                    }}
                  >
                    <div className="progress-value d-block text-light title-dark h6">
                      {county.rating.tax_rate
                        ? Math.ceil(county.rating.tax_rate * 100)
                        : 0}{" "}
                      %
                    </div>
                  </div>
                </div>
              </div>
              <div className="progress-box mt-4">
                <h6 className="title text-light title-dark">Poverty Rate</h6>
                <div
                  className="progress title-bg-dar mt-4"
                  style={{ height: "10px", padding: "3px" }}
                >
                  <div
                    className="progress-bar position-relative bg-black"
                    style={{
                      width: `${
                        county.rating.poverty_rate
                          ? Math.ceil(county.rating.poverty_rate)
                          : 0
                      }%`,
                    }}
                  >
                    <div className="progress-value d-block text-light title-dark h6">
                      {county.rating.poverty_rate
                        ? Math.ceil(county.rating.poverty_rate)
                        : 0}{" "}
                      %
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default SectionIncome
